<template>
    <div id="copyrightRegistration" class="toRegDetail">
        <div class="main">
            <div class="title">
                版权登记
            </div>
            <div class="tabTit">
                <div class="tit">
                    权力权属:
                </div>
                <div class="item_content">
                    <RadioGroup class="radio_group monitor_type"
                                v-model="form.copyrightType"
                                @on-change="powerChange">
                        <Radio class="radio_item" label="1">
                            <span class="radio_item_name">个人作品</span>
                        </Radio>
                        <Radio class="radio_item" label="3">
                            <span class="radio_item_name">法人作品</span>
                        </Radio>
                        <Radio class="radio_item" label="2">
                            <span class="radio_item_name">合作作品</span>
                        </Radio>
                        <Radio class="radio_item" label="4">
                            <span class="radio_item_name">职务作品</span>
                        </Radio>
                        <Radio class="radio_item" label="5">
                            <span class="radio_item_name">委托作品</span>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <div class="item_wrap">
                <div class="author">
                    <div class="item">
                        <div class="tit">
                            作者:
                        </div>
                        <div class="content_wrap">
                            <div style="display:flex;justify-content:flex-start;align-items: center;">
                                <div v-for="(item,index) in autors" :key="index" class="show_autor_Picture">
                                    <div class="showSc_autor">
                                        <button class="autors_class">{{item.name}}</button>
                                        <img @click.stop="deleteAutor(item)" class="showshanchu"
                                             src="./images/CombinedShape.png" alt='版权登记'/>
                                    </div>
                                </div>
                                <!--								<input type="button" value="+添加权利人" class="form_input_btn_select" @click="addAutor('autor')"/>-->
                                <div class="btn_wrap">
                                    <div class="btn" @click="addAutor('autor')">选择作者</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="owner">
                    <div class="item">
                        <div class="tit">
                            著作权人:
                        </div>
                        <div class="content_wrap">
                            <div style="display:flex;justify-content:flex-start;align-items: center;">
                                <div v-for="(item,index) in obligees" :key="index" class="show_autor_Picture">
                                    <div class="showSc_autor">
                                        <button class="autors_class">{{item.name}}</button>
                                        <img @click.stop="deleteObligee(item)" class="showshanchu"
                                             src="./images/CombinedShape.png" alt='版权登记'/>
                                    </div>
                                </div>
                                <div class="btn_wrap">
                                    <div class="btn" @click="addAutor('obligee')">选择著作权人</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="works_type">
                    <div class="item">
                        <div class="tit">
                            作品类型:
                        </div>
                        <div class="content_wrap">
                            <el-cascader v-model="form.workType" :options="workTypes" placeholder="请选择作品类型"
                                         @change="workTypeChange()"></el-cascader>
                        </div>
                    </div>
                </div>
                <div class="works_name">
                    <div class="item">
                        <div class="tit">
                            作品名称:
                        </div>
                        <div class="content_wrap">
                            <el-input placeholder="请输入作品名称" v-model="form.workFullName" style="width: 372px"/>
                            <!--							<input v-model="form.workFullName"  class="form_input_1"/>-->
                        </div>
                    </div>
                </div>
                <div class="works_file">
                    <div class="item">
                        <div class="tit">
                            作品文件:
                        </div>
                        <div class="content_wrap">
                            <div class="certList_right">
                                <div class="certList_right_top">
                                    <MyUploadHw :oldShowList="worksList" :fileMultiue="true" textContent="添加作品样本"
                                                :accept="workType_fileAccept"
                                                :maxNumber="maxNumber"
                                                @listentochildevent="showmessagefromchild"/>
                                    <div class="showtextDf">
                                        <div>温馨提示：</div>
                                        <!--                                <p>1、同一批的存证文件归属于同一标签，不支持重置；</p>-->
                                        <p>1、文件数量6个以内；</p>
                                        <p>2、上传文件大小100M以内；</p>
                                        <!--                                <p>4、文件永久保全。</p>-->
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:flex-start;">
                                    <div v-for="(item,index) in worksList" :key="index" class="show_Picture">
                                        <div class="showSc">
                                            <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                                 :src="item.url"/>
                                            <span class="showDelete"><img @click.stop="deleteList(item)"
                                                                          class="showshanchu"
                                                                          src="./images/shanchu.png" alt='版权登记'/></span>
                                        </div>
                                        <div>{{item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="works_character">
                    <div class="item">
                        <div class="tit">
                            作品创作性质:
                        </div>
                        <div class="content_wrap">
                            <el-cascader v-model="form.creativeType" :options="creativeTypes"
                                         placeholder="请选择作品创作性质"></el-cascader>
                        </div>
                    </div>
                </div>
                <div class="works_time">
                    <div class="item">
                        <div class="tit">
                            创作完成时间:
                        </div>
                        <div class="content_wrap">
                            <DatePicker type="date" style="width: 222px;" v-model="form.completeDateEnd"
                                        :options="options_create" :value="form.completeDateEnd" placeholder="选择日期"
                                        class="datePickerClass"></DatePicker>
                        </div>
                    </div>
                </div>
                <div class="works_add">
                    <div class="item">
                        <div class="tit">
                            作品完成地点:
                        </div>
                        <div class="content_wrap">
                            <el-cascader v-model="placeOfCompletion" :options="citys"></el-cascader>
                        </div>
                    </div>
                </div>
                <div class="works_state">
                    <div class="item">
                        <div class="tit">
                            作品发表状态:
                        </div>
                        <div class="content_wrap">
                            <div style="display: flex;width: 1170px;">
                                <el-cascader v-model="form.publishStatus" :options="publishStatusArr"
                                             placeholder="请选择作品发表状态"></el-cascader>
                                <div v-if="form.publishStatus == '1'" class="publish_status">
                                    <span class="pulish_status_span">作品发表时间</span>
                                    <DatePicker type="date" v-model="form.publishDate" :options="options_publish"
                                                placeholder="选择日期" class="datePickerClass"></DatePicker>
                                    <span class="pulish_status_span">作品发表地点</span>
                                    <el-cascader v-model="placeOfPublication" :props="{ value: 'label' }"
                                                 :options="citys"></el-cascader>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <!--				<div class="clearfox"></div>-->
                <div class="works_file">
                    <div class="item">
                        <div class="tit">
                            附件:
                        </div>
                        <div class="content_wrap">
                            <div class="certList_right">
                                <div class="certList_right_top">
                                    <MyUploadHw :oldShowList="enclosureList" :fileMultiue="true" accept=".jpg,.png"
                                                textContent="附件上传"
                                                :maxNumber="maxNumber"
                                                @listentochildevent="showmessagefromchild1"/>
                                    <div class="showtextDf">
                                        <div>温馨提示：</div>
                                        <p>1、请将与作品权属相关的文件（例如签署的协议，合同等）上传在此处；</p>
                                        <p>2、要求格式jpg、png，大小100M以内，最多上传6个附件；</p>
                                        <p style="color: #000000;">（此处为附件上传，请不要将作品文件传在此处）</p>
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:flex-start;">
                                    <div v-for="(item,index) in enclosureList" :key="index" class="show_Picture">
                                        <div class="showSc">
                                            <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                                 :src="item.url" alt='版权登记'/>
                                            <span class="showDelete"><img @click.stop="deleteList_fj(item)"
                                                                          class="showshanchu"
                                                                          src="./images/shanchu.png" alt='版权登记'/></span>
                                        </div>
                                        <div>{{item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="works_declare"
                     v-if="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'">
                    <div class="item">
                        <div class="tit">
                            创作声明:
                        </div>
                        <div class="content_wrap">
                            <div>
                                <div style="display: flex;">
                                    <MyUploadHw :oldShowList="statementList" :fileMultiue="false" accept=".jpg,.png"
                                                styleType="btn" @listentochildevent="showmessagefromchild2"/>
                                    <span v-if="declare_upload_success" style="margin-left: 20px;margin-top:10px;">{{declare_file_name}}</span>
                                    <a :href="[declare_down_urls[form.copyrightType]]" target='_blank'
                                       download='合作声明.docx' class="creatInfo-span">下载模板</a>
                                    <span style="margin-top:10px;">｜</span>
                                    <u class="declare_sample" @click="showDeclareSample">查看样例</u>
                                </div>
                                <div className="tipUpload">
                                </div>
                                <p style="margin-top:10px;">
                                    温馨提示：请按照模板样例内容仔细填写，注意个人需手写签字，企业需加盖公章，填写完成后拍照上传。格式jpg,png，大小10M以内。</p>
                                <p style="padding-left: 70px;margin-top: 10px;">重新上传，会覆盖原来的文件。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="works_possess">
                    <div class="item">
                        <div class="tit">
                            权益拥有情况:
                        </div>
                        <div class="content_wrap">
                            <div><input type="checkbox" v-model="isSlectedAll"
                                        style="margin-right: 10px;"/><span>全选</span></div>
                            <div class="owner_checkbox">
                                <p v-for="(item,index) in Ownership" :key="index">
                                    <input type="checkbox" v-model="item.checked"/><span>{{item.label}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="works_intention">
                    <div class="item">
                        <div class="tit">
                            创作意图:
                        </div>
                        <div class="content_wrap">
                            <el-input type="textarea" :rows="4" placeholder="请输入内容" maxlength="500"
                                      style="width: 760px;"
                                      show-word-limit v-model="form.createIntention"></el-input>
                            <span>(选填)</span>
                        </div>
                    </div>
                </div>
                <div class="works_create">
                    <div class="item">
                        <div class="tit">
                            作品独创性:
                        </div>
                        <div class="content_wrap">
                            <el-input type="textarea" :rows="4" placeholder="请输入内容" maxlength="500" style="width: 760px"
                                      show-word-limit v-model="form.creationOriginality"></el-input>
                            <span>(选填)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub">
            <div class="btn" @click="addcert" :disabled="isDisabled">
                提交
            </div>
        </div>

        <CertAutorVerify v-if="isAddAutor" :obligeeArr="chooseObligeeArr" :is-radio="powerIsRadio"
                         :my-title="verifyTitle" @fatherModal="chooseAutor"/>
        <DeclareSample v-show="isShowDeclare" :declare-type="declareSrc" @fatherModal="isShowDeclare=false"/>
    </div>
</template>

<script>
    import {cityCode} from "@/libs/cityCode";
    import {_getByPage} from "@/api/obligee.js";
    // import {_save,_getDetail,_resubmit} from "../../../api/register";
    import {_save} from "@/api/register";
    import Cookies from "js-cookie";
    import MyUploadHw from '@/views/main-components/my-upload-hw';
    import Timeline from '@/views/main-components/horizontal-timeline';
    import CertAutorVerify from "./cert-autor-verify";
    import '@/plugins/element.js';
    import DeclareSample from "./declareSample";
    import {_saveData, _getObligeeParams} from "./cpRegistData";
    import util from '@/libs/util'

    const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;


    export default {
        name: "copyrightLogin",
        components: {
            MyUploadHw,
            Timeline, CertAutorVerify, DeclareSample
        },
        data() {
            return {

                test: ["中国", "北京市", "东城区"],
                // test:["0","110000","110101"],
                originObligeeArr: [],//著作人的数据
                chooseObligeeArr: [], //点击弹窗，里面的内容
                isAddAutor: false, //是否添加作者/著作人
                citys: [], //城市
                getObligeeParams: [], //获取作者/著作人的参数
                //作品类型
                workTypes: [{label: "设计手稿", value: "1"}, {label: "设计图", value: "2"}, {
                    label: "产品摄影",
                    value: "3"
                }, {label: "产品视频", value: "4"}, {label: "设计创意稿", value: "5"}],//作品类型
                //作品性质
                creativeTypes: [
                    {label: "原创", value: "1"}, {label: "改编", value: "2"}, {label: "翻译", value: "3"},
                    {label: "汇编", value: "4"}, {label: "注释", value: "5"}, {label: "整理", value: "6"}, {
                        label: "其他",
                        value: "7"
                    }
                ],
                publishStatusArr: [{label: "未发表", value: "0"}, {label: "已发表", value: "1"}],

                isShowDeclare: false, //显示合作声明图片
                declareSrc: "3", //查看声明图片地址
                declare_down_urls: ["", "", "http://pub-bluefile.bqj.cn/urkunde/c5046b2000a768efd5c4ce7bd2ee0171.docx",
                    "",
                    "http://pub-bluefile.bqj.cn/urkunde/3211eb99fb9c16907cdec30886a2aad0.docx",
                    "http://pub-bluefile.bqj.cn/urkunde/bbd17aee92606185f38f2a6520b99e06.docx"
                ],//声明 下载地址
                declare_file_names: ["", "", "合作作品创作声明", "", "职务作品创作声明", "委托作品创作声明"],
                declare_upload_success: false,
                declare_file_name: "",
                // 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
                powers: [{label: "个人作品", checked: true, value: "1"}, {label: "法人作品", checked: false, value: "3"},
                    {label: "合作作品", checked: false, value: "2"}, {label: "职务作品", checked: false, value: "4"},
                    {label: "委托作品", checked: false, value: "5"}],
                ////权力权属
                Ownership: [
                    {label: '发表权', value: '1', checked: false},
                    {label: '署名权', value: '2', checked: false},
                    {label: '修改权', value: '3', checked: false},
                    {label: '保护作品完整权', value: '4', checked: false},
                    {label: '复制权', value: '5', checked: false},
                    {label: '发行权', value: '6', checked: false},
                    {label: '出租权', value: '7', checked: false},
                    {label: '展览权', value: '8', checked: false},
                    {label: '表演权', value: '9', checked: false},
                    {label: '放映权', value: '10', checked: false},
                    {label: '广播权', value: '11', checked: false},
                    {label: '信息网络传播权', value: '12', checked: false},
                    {label: '摄制权', value: '13', checked: false},
                    {label: '改编权', value: '14', checked: false},
                    {label: '翻译权', value: '15', checked: false},
                    {label: '汇编权', value: '16', checked: false},
                    {label: '其他', value: '17', checked: false},
                ],//权益拥有情况
                declare_fileAccept: ".png,.jpg",
                declare_fileFormat: [".png", ".jpg"],
                workType_fileAccept: ".bmp,.png,.jpg,.gif,.jpeg",
                autors: [], //作者
                obligees: [],//权人

                worksList: [],//作品
                enclosureList: [],//附件
                statementList: [],//创作声明
                powerIsRadio: "false",
                maxNumber: 6,
                form: {},
                copyrightDetailsId: "",
                isReset: false,
                keepAliveData: {},
                oldCopyrightType: "1",
                isDisabled: false,
                rules: {
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'}
                    ], //音乐名称
                    files: [{required: true, message: '请选择文件', trigger: 'blur'}], //音乐文件
                    autor: [{required: true, message: '请添加权利人', trigger: 'blur'}], //作者
                    obligee: [{required: true, message: '请添加权利人', trigger: 'blur'}],//权人
                },
                music: require('@/assets/music_icon.png'),
                text: require('@/assets/text_icon.png'),
                video: require('@/assets/video_icon.png'),
                other: require('@/assets/file_icon.png'),
                options_create: {
                    disabledDate(date) {
                        //如果可以包含当天，那么 就不用减去8640000，如果不能包含当天，则需要减去
                        return date && date.valueOf() > Date.now() - 86400000;
                    }
                },
                options_publish: {
                    disabledDate: (date) => {
                        console.log(this.form.completeDateEnd);
                        let d = new Date(this.form.completeDateEnd);
                        // console.log("d ====>>>> ",d);
                        return date && !(date.valueOf() < Date.now() && date.valueOf() > d);
                    }
                },
                placeOfCompletion: [], //作品完成地点
                placeOfPublication: [], //作品发表地点
            }
        },
        created() {
            console.log("created :::::::::: ", _saveData);

            this.getObligeeParams = _getObligeeParams;

            let _this = this;
            let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : "";

            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.isReset = true;
                this.getDetail();
            } else {
                this.form = {..._saveData};
            }

            if (userInfo) {
                console.log(userInfo)
                this.getObligeeParams.registerId = userInfo.id;
                this.getByPage(this.getObligeeParams);
            }
        },
        mounted() {
            this.citys = cityCode;
        },

        computed: {
            isSlectedAll: {
                get() {
                    let isAll = true;
                    this.Ownership.forEach(item => {
                        if (item.checked == false) {
                            isAll = false;
                            return;
                        }
                    })
                    return isAll;
                },
                set(value) {
                    this.selectAll(value);
                }
            }
        },
        methods: {
            /*********获取作者/著作人***************/
            async getByPage(parms) {
                // //debugger;
                let _this = this;
                let res = await _getByPage(parms);
                if (res.code == "200") {
                    let data = res.result.records;
                    data.forEach(item => {
                        item.checked = false;
                    });
                    _this.originObligeeArr = data;

                    if (this.isReset == true) {
                        //作者处理 originObligeeArr
                        _this.autors = [];
                        _this.form.authorIds.forEach(value => {
                            console.log(value);
                            for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                console.log(_this.originObligeeArr[i]);
                                if (_this.originObligeeArr[i].id == value)
                                    _this.autors.push(_this.originObligeeArr[i]);
                            }
                        });
                        //著作人处理
                        // //debugger ;
                        _this.obligees = [];
                        _this.form.powerIds.forEach(value => {
                            for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                if (_this.originObligeeArr[i].id == value)
                                    _this.obligees.push(_this.originObligeeArr[i]);
                            }
                        });
                    }
                }

            },
            /************获取登记详情***********/
            getDetail() {
                console.log("***********获取登记详情***********")
                let _this = this;
                let data = {orderSeqNo: this.copyrightDetailsId};
                _getDetail(data).then(res => {
                    if (res.code == 200) {
                        _this.form = _saveData;
                        Object.assign(_this.form, res.result);
                        _this.form = res.result;
                        //特殊处理，数据库返回来得字段，与传值字段不一样
                        _this.form.workType = _this.form.workTypeDesc;//文字，看一会是不是需要转化成数字

                        _this.form.workUrl = _this.form.worksAttachments;
                        _this.form.completeDateEnd = _this.form.completeDate;
                        //权力权属，获取到得是文字
                        _this.form.copyrightType = _this.getValueByLabel(_this.form.copyrightType, _this.powers);
                        _this.oldCopyrightType = _this.form.copyrightType;

                        //作品类型 处理
                        _this.form.workType = _this.getValueByLabel(_this.form.workTypeDesc, _this.workTypes);
                        //作品文件处理
                        _this.worksList = [];
                        _this.form.workUrl.forEach((value, index) => {
                            let obj = {};
                            obj.attachmentUrl = value;
                            obj.url = util.thumbnail(value);
                            obj.name = "作品" + (index + 1) + "." + value.split(".")[1];
                            _this.worksList.push(obj);
                        });
                        //作品创作性质 处理
                        _this.form.creativeType = _this.getValueByLabel(_this.form.creativeType, _this.creativeTypes);
                        //时间得处理

                        //完成 地点得处理
                        let arr = [];
                        //debugger ;
                        arr.push(_this.form.completeCountry);
                        arr.push(_this.form.completeProvince);
                        arr.push(_this.form.completeCity);
                        _this.placeOfCompletion = arr;

                        //附件处理
                        if (_this.form.otherAttachments != "" || _this.form.otherAttachments != null) {
                            _this.enclosureList = [];
                            if (_this.form.otherAttachments[0] != "") {
                                _this.form.otherAttachments.forEach((value, index) => {
                                    let obj = {};
                                    obj.attachmentUrl = value;
                                    obj.url = util.thumbnail(value);
                                    obj.name = "附件" + (index + 1) + "." + value.substr(value.length - 4, 4);
                                    _this.enclosureList.push(obj);
                                });
                            } else {
                                _this.form.otherAttachments = "";
                            }
                        }

                        //debugger ;
                        _this.form.publishStatus = _this.getValueByLabel(_this.form.publishStatus, _this.publishStatusArr);

                        if (_this.form.publishStatus == "1") {
                            //发表地点的 处理
                            if (_this.form.publishCity != "" || _this.form.publishCity != null) {
                                let parr = [];
                                parr.push(_this.form.publishCountry);
                                parr.push(_this.form.publishProvince);
                                parr.push(_this.form.publishCity);
                                _this.placeOfPublication = parr;
                            }
                        }

                        //创作声明
                        if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {

                            _this.statementList[0] = {
                                attachmentUrl: _this.form.workInstruction,
                                url: _this.form.workInstruction,
                                name: "创作声明"
                            };
                            this.declare_file_name = _this.declare_file_names[Number(_this.form.copyrightType)] + _this.form.workInstruction.substr(_this.form.workInstruction.length - 4, 4);
                            _this.declare_upload_success = true; //显示创作声明的文本标签是否显示
                        }
                        //权力权益
                        _this.form.powerScope.split(",").forEach(value => {
                            _this.Ownership[value - 1].checked = true;
                        })

                        //创作意图
                        _this.form.createIntention = _this.form.creationIntentions;


                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },

            //通过名称获取value，用于权力权属，作品类型，作品性质，发表状态
            getValueByLabel(name, originArr) {
                let value = "";
                originArr.forEach(item => {
                    if (item.label == name)
                        value = item.value;
                });
                return value;
            },

            powerChange() {
                let that = this;
                //console.log(this.form.copyrightType);
                //如果权力权益发生变化，那么，创作声明都需要重新上传文件
                let currValue = this.form.copyrightType;
                this.declare_file_name = "";
                this.declare_upload_success = false;
                console.log(this.keepAliveData);
                // if(this.keepAliveData[this.oldCopyrightType] == null){
                console.log('进1')
                var obj = {};
                obj.form = {...this.form};
                obj.autors = [...this.autors];
                obj.obligees = [...this.obligees];
                obj.worksList = [...this.worksList];//作品
                obj.enclosureList = [...this.enclosureList];//附件
                obj.statementList = [...this.statementList];//创作声明
                this.keepAliveData[this.oldCopyrightType] = {...obj};
                // }
                //把当前的权利归属字段赋给记录字段
                this.oldCopyrightType = this.form.copyrightType;

                if (this.keepAliveData[this.form.copyrightType] != null) {
                    console.log('进2')
                    let obj = {...this.keepAliveData[this.form.copyrightType]};
                    console.log(obj);
                    this.form = obj.form;
                    this.autors = obj.autors;
                    this.obligees = obj.obligees;
                    this.worksList = [];
                    that.$nextTick(function () {
                        that.worksList = obj.worksList;
                    });

                    // this.worksList = obj.worksList;
                    this.enclosureList = obj.enclosureList;
                    this.statementList = obj.statementList;
                } else {
                    console.log('进3')
                    this.form = _saveData;
                    this.autors = [];
                    this.obligees = [];
                    this.worksList = [];
                    this.statementList = [];
                    this.enclosureList = [];
                }
                //这里需要把当前的权利归属字段重新赋值给form,因为这里form进行了重新赋值，而_saveData里面，权利归属的初始值是1，是个人
                this.form.copyrightType = currValue;
            },

            //作品类型发生改变
            workTypeChange() {
                // alert(this.form.workType);
                if (this.form.workType == "4") {
                    this.workType_fileAccept = ".avi,.mpeg,.3gp,.mp3,.wav,.mov,.mp4";
                } else {
                    this.workType_fileAccept = ".bmp,.png,.jpg,.gif,.jpeg";
                }
            },

            //添加作者，弹出添加作者窗口
            addAutor(flag) {
                this.autorOrObligee = flag;
                this.verifyTitle = this.autorOrObligee == "autor" ? "添加作者" : "添加著作人";
                //个人作品，作者和著作人是一个人，选择一个  obligeeType person：“个人” enterprise “企业”
                this.powerIsRadio = "false"; //false 复选，true：单选
                let data = [];
                this.chooseObligeeArr = [];
                // debugger ;
                console.log("选择作者，当前类型 ：： ", this.form.copyrightType);
                if (this.form.copyrightType == "1") {
                    data = this.originObligeeArr.filter(item => {
                        return item.obligeeType == "person";
                    });
                    if (data.length == 0) {
                        toast("您还没有添加企业权利人，请先添加权利人再来登记");
                        return false;
                    }
                    this.powerIsRadio = "true";
                }
                // 法人作品，作者和著作人只能是企业，只能选一个
                else if (this.form.copyrightType == "3") {
                    this.powerIsRadio = "true";
                    data = this.originObligeeArr.filter(item => {
                        return item.obligeeType == "enterprise";
                    });

                    if (data.length == 0) {
                        toast("您还没有添加企业，请先添加企业再来登记");
                        return false;
                    }
                }
                // 职务，作者可以多个，著作权人只能是一个
                else if (this.form.copyrightType == "4" && this.autorOrObligee != "autor") {
                    this.powerIsRadio = "true";
                    data = this.originObligeeArr;
                } else {
                    data = this.originObligeeArr;
                }

                this.chooseObligeeArr = [...data.map(aInfo => {
                    return Object.assign({}, aInfo)
                })]

                this.isAddAutor = true;
            },
            //关闭 添加作者窗口，获取选中得作者
            chooseAutor(data) {
                this.isAddAutor = false;

                if (!data) {
                    return
                }
                //个人作品，作者和著作人是一个人，选择一个，两个都变
                if (this.form.copyrightType == "1") {
                    this.autors = [...data];
                    this.obligees = [...data];
                }
                //法人作品，作者和著作人 只能选一个
                else if (this.form.copyrightType == "3") {
                    if (this.autorOrObligee == "autor")
                        this.autors = [...data];
                    else
                        this.obligees = [...data];
                }
                // 职务，著作权人只能是一个
                else if (this.form.copyrightType == "4" && this.autorOrObligee != "autor") {
                    this.obligees = [...data];
                } else {
                    if (this.autorOrObligee === "autor") {
                        let arr = [...this.autors, ...data];
                        this.autors = arr.reduce((acc, cur) => {
                            !acc.some(v => v.name === cur.name) && acc.push(cur);
                            return acc;
                        }, []);
                    } else if (this.autorOrObligee === "obligee") {
                        let arr = [...this.obligees, ...data];
                        this.obligees = arr.reduce((acc, cur) => {
                            !acc.some(v => v.name === cur.name) && acc.push(cur);
                            return acc;
                        }, []);
                    }
                }
            },
            //删除作者
            deleteAutor(item) {
                this.autors.splice(this.autors.indexOf(item), 1);
            },
            //删除著作人
            deleteObligee(item) {
                this.obligees.splice(this.obligees.indexOf(item), 1);
            },

            //查看声明样例
            showDeclareSample() {
                this.declareSrc = this.form.copyrightType;
                this.isShowDeclare = true;
            },

            //提交
            addcert() {
                // $("#addcertButton").attr("disabled","disabled");
                let _this = this;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                if (userInfo.length == 0) {
                    toast('请登录后再操作', function () {
                        _this.$router.push({
                            path: '/'
                        })
                    })
                    return false;
                }
                /**
                 * 判断作者和著作人
                 * 1 判断是否为空
                 * 2 如果是合作作品 ，则作者和著作权人都必须大于等于2
                 */
                console.log("_this.autors", _this.autors);
                if (_this.autors.length <= 0 || _this.obligees.length <= 0) {
                    toast("请选择作者和著作人");
                    return false;
                } else if (_this.form.copyrightType == "2" && (_this.autors.length < 2 || _this.obligees.length < 2)) {
                    toast("合作作品，作者和著作人都必须大于等于2个");
                    return false;
                } else {
                    let aid = "";
                    let oid = "";
                    _this.autors.forEach(item => {
                        aid += item.id + ",";
                    })
                    _this.obligees.forEach(item => {
                        oid += item.id + ",";
                    })
                    _this.form.authorIds = aid.substr(0, aid.length - 1);
                    _this.form.powerUserIds = oid.substr(0, oid.length - 1);
                }

                //判断作品名称
                if (_this.form.workFullName == "") {
                    toast("请填写作品名称")
                    return false;
                }

                //判断作品文件
                if (_this.worksList.length <= 0) {
                    toast("请填选择作品文件")
                    return false;
                } else {
                    let chanShowList = _this.worksList;
                    let urls = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                    }
                    if (_this.urls == '') {
                        toast('请选择要上传的作品文件')
                        return false;
                    } else {
                        _this.form.workUrl = urls;
                    }
                }

                //判断作品创作性质
                if (_this.form.creativeType == "") {
                    toast("请选择作品创作性质")
                    return false;
                } else {
                    _this.form.creativeType = _this.form.creativeType[0];
                }

                //判断 作品创作类型
                if (_this.form.workType == "") {
                    toast("请选择作品类型")
                    return false;
                } else {
                    _this.form.workType = _this.form.workType[0];
                }


                // 创作完成时间
                if (_this.form.completeDateEnd == "") {
                    toast("请选择创作完成时间")
                    return false;
                } else {
                    let dt = new Date(_this.form.completeDateEnd);
                    let year = dt.getFullYear();
                    let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                    let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                    _this.form.completeDateEnd = year + "-" + month + "-" + date;
                }

                //debugger ;
                //作品完成地点
                console.log("作品完成地点：：：", _this.placeOfCompletion);
                if (!_this.placeOfCompletion || _this.placeOfCompletion == "") {
                    toast("请选择作品完成地点")
                    return false;
                } else {
                    _this.form.completeCountry = _this.placeOfCompletion[0];
                    _this.form.completeProvince = _this.placeOfCompletion[1];
                    _this.form.completeCity = _this.placeOfCompletion[2];
                }
                console.log(_this.form.publishStatus)
                if (!_this.form.publishStatus || _this.form.publishStatus == '') {
                    toast("请选择作品发表状态")
                    return false

                }
                _this.form.publishStatus = _this.form.publishStatus[0];
                //发表状态 如果时已发表，则判断发表时候的地点和时间
                if (_this.form.publishStatus == "1") {
                    //发表完成时间
                    if (_this.form.publishDate == "") {
                        toast("请选择创作发表时间")
                        return false;
                    } else {
                        let dt = new Date(_this.form.publishDate);
                        let year = dt.getFullYear();
                        let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                        let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                        _this.form.publishDate = year + "-" + month + "-" + date;
                    }
                    //发表完成地点
                    console.log("作品发表地点：：：", _this.placeOfPublication);
                    if (!_this.placeOfPublication || _this.placeOfPublication == "") {
                        toast("请选择作品发表地点")
                        return false;
                    } else {
                        _this.form.publishCountry = _this.placeOfPublication[0];
                        _this.form.publishProvince = _this.placeOfPublication[1];
                        _this.form.publishCity = _this.placeOfPublication[2];
                    }
                } else {
                    _this.form.publishDate = '';
                    _this.placeOfPublication = [];
                    _this.form.publishCountry = '';
                    _this.form.publishProvince = '';
                    _this.form.publishCity = '';

                }

                // 附件 也可以为空
                if (_this.enclosureList.length > 0) {
                    let chanShowList = _this.enclosureList;
                    let urls = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                    }
                    _this.form.otherAttachments = urls;
                }

                //创作声明的判断
                if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {
                    if (_this.statementList.length <= 0) {
                        toast("请选择创作声明")
                        return false;
                    } else {
                        let chanShowList = _this.statementList;
                        let urls = '';
                        for (let i = 0; i < chanShowList.length; i++) {
                            urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                        }
                        if (_this.urls == '') {
                            toast('请选择要上传的作品文件')
                            return false;
                        } else {
                            _this.form.workInstruction = urls;
                        }
                    }
                }

                //权益拥有情况
                let isHaveSelect = false;
                let powerScopeType = "";
                _this.Ownership.forEach(item => {
                    if (item.checked == true) {
                        isHaveSelect = true;
                        powerScopeType += item.value + ","
                    }
                });
                if (isHaveSelect == false) {
                    toast('请选择权益拥有情况')
                    return false;
                }
                console.log("powerScopeType :: ", powerScopeType);
                _this.form.powerScope = powerScopeType.substr(0, powerScopeType.length - 1);

                //独创性和创作意图可以为空
                // 提交

                //debugger ;
                console.log("登记的传参  :: ", _this.form);
                if (_this.isReset == true) {
                    _this.form.orderSeqNo = _this.copyrightDetailsId;
                    _this.form.powerBy = "1";
                    _this.isDisabled = true;
                    _resubmit(_this.form).then(res => {
                        this.resultJ(res);
                    });

                } else {
                    _this.isDisabled = true;
                    _save(_this.form).then(res => {
                        this.resultJ(res);
                    });
                }
                ;
            },
            resultJ(res) {
                console.log("登记提交后的返回结果：：：", res);
                console.log('提交成功后的回调', res)
                if (res.code == 200) {
                    toast('登记保存成功')
                    this.$router.push({path: '/myDci'})
                } else if (res.code == 213) {
                    toast("请实名认证后使用功能")
                    this.$router.push('/authentication')
                } else if (res.code == 214) {
                    toast("请购买会员后使用功能")
                    if (userInfo.accountType == "person") {
                        this.$router.push('/vipPersonal')
                    } else {
                        this.$router.push('/vipEnterprise')
                    }
                } else if (res.code == 216) {
                    // this.monitorBagState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false;
                } else if (res.code == 215) {
                    toast("VIP已到期，请续费")
                    this.myczPayState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false;
                } else {
                    toast(res.message)
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false;
                }

            },
            //上传作品文件
            showmessagefromchild(data) {
                let _this = this;
                console.log('+++++++++++++++++++++++++++++++++++', data)
                for (let i = 0; i < data.length; i++) {
                    let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        // 	data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url)
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }
                console.log('获取接口后的存证数据', data)
                _this.worksList = data
            },
            //删除作品文件
            deleteList(item) {
                // //debugger ;
                this.worksList.splice(this.worksList.indexOf(item), 1);
            },
            //上传附件
            showmessagefromchild1(data) {
                let _this = this;
                console.log('+++++++++++++++++++++++++++++++++++', data)
                for (let i = 0; i < data.length; i++) {
                    let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        // 	data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url)
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }
                console.log('获取接口后的存证数据', data)
                _this.enclosureList = data
            },
            //删除附件
            deleteList_fj(item) {
                this.enclosureList.splice(this.enclosureList.indexOf(item), 1);
            },
            //创作声明，只有一个文件
            showmessagefromchild2(data) {
                let _this = this;
                let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
                if (reImg.test(layout)) {
                    // if(data[0].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                    // 	data[0].url = data[0].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                    // }
                    data[0].url = util.thumbnail(data[0].url);
                } else {
                    data[0].url = _this.other;
                }


                _this.declare_upload_success = true;
                _this.declare_file_name = _this.declare_file_names[_this.form.copyrightType] + "." + layout;

                console.log('获取接口后的存证数据', data)
                _this.statementList = data
            },
            //权益拥有情况 全选
            selectAll(value) {
                this.Ownership.forEach(item => item.checked = value);
            }
        }
    }
</script>

<style scoped lang="less">
    .toRegDetail {
        padding-top: 20px;
        background-color: rgba(241, 244, 248, 1);

        .main {
            width: 1334px;
            margin: 0 auto;

            .title {
                width: 100%;
                height: 63px;
                padding-left: 25px;
                font-size: 20px;
                color: #333;
                line-height: 63px;
                background-color: #fff;
                border-radius: 2px 2px 0 0;
                box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            }

            .tabTit {
                width: 100%;
                height: 68px;
                background-color: #fff;
                box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                padding-left: 42px;

                .tit {
                    font-size: 14px;
                    color: #666;
                    line-height: 68px;
                    margin-right: 50px;
                    float: left;
                }

                .ivu-radio-group {
                    font-size: 20px;
                    color: #999;
                    line-height: 68px;
                }

                .radio_group .radio_item_name {
                    margin-left: 4px;
                    font-size: 14px;
                    color: #666666;
                    margin-right: 72px;
                    transition: none;
                    transform: none;
                }

            }

            /*作者*/

            .item_wrap {
                .item {
                    width: 100%;
                    height: 80px;
                    background-color: #fff;
                    border: 1px solid rgba(238, 238, 238, 1);
                    border-left: none;
                    border-right: none;

                    .tit {
                        width: 100px;
                        height: 80px;
                        line-height: 80px;
                        float: left;
                        margin-left: 40px;
                        margin-right: 24px;
                        font-size: 14px;
                        color: #666;
                        text-align: left;
                    }

                    .content_wrap {
                        width: 1170px;
                        height: 80px;
                        float: left;
                        padding-top: 22px;

                        .btn_wrap {
                            float: left;

                            .btn {
                                width: 120px;
                                height: 38px;
                                background-color: #ffd800;
                                color: #4e4e4e;
                                line-height: 38px;
                                text-align: center;
                                border-radius: 2px;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .works_file {
                    height: 390px;

                    .item {
                        height: 390px;
                    }

                    .content_wrap {
                        padding-top: 25px;
                    }

                }

                .works_state {
                    width: 100%;
                    height: 80px;
                    background-color: #fff;

                    .item {
                        width: 540px;
                        float: left;

                        .content_wrap {
                            width: 376px;
                        }
                    }
                }

                .works_declare {
                    width: 100%;
                    height: 140px;

                    .item {
                        height: 140px;
                    }

                    /*合作声明*/

                    .creatInfo-span {
                        margin-left: 30px;
                        margin-right: 10px;
                        margin-top: 10px;
                        width: 56px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(18, 18, 16, 1);
                        text-decoration: underline;
                    }

                    .declare_sample {
                        margin-left: 10px;
                        margin-top: 10px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        cursor: pointer;
                    }
                }

                .works_possess {
                    height: 170px;

                    .item {
                        height: 170px;
                    }

                    .content_wrap {
                        padding: 34px;
                        width: 800px;

                        .owner_checkbox {
                            width: 690px;
                            display: flex;
                            flex-direction: row;
                            flex-wrap: wrap;
                            margin-top: 10px;

                            p {
                                margin-right: 40px;
                                margin-bottom: 5px;

                                input {
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }

                .works_intention {
                    height: 168px;

                    .item {
                        height: 168px;

                        textarea {
                            width: 760px;
                            height: 100px;
                            padding: 15px;
                            resize: none;
                        }
                    }
                }

                .works_create {
                    height: 168px;

                    .item {
                        height: 168px;

                        textarea {
                            width: 760px;
                            height: 100px;
                            padding: 15px;
                            resize: none;
                        }
                    }
                }
            }
        }

        /*提交按钮*/

        .sub {
            width: 100%;
            height: 126px;
            padding-top: 30px;

            .btn {
                width: 124px;
                height: 42px;
                background-color: #ffd800;
                color: #4e4e4e;
                font-size: 14px;
                text-align: center;
                line-height: 42px;
                margin: 0 auto;
                cursor: pointer;
            }
        }
    }


    .certList_right {
        display: flex;
        flex-direction: column;

        .certList_right_top {
            height: 194px;
            display: flex;
            justify-content: flex-start;

            .showtextDf {
                margin-left: 20px;

                div {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 20px;
                    margin-top: 64px;
                    margin-bottom: 10px;
                }

                p {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 20px;
                }
            }
        }
    }


    .show_Picture {
        margin-right: 20px;

        div {
            width: 103px;
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 5px;
        }

        .showSc {
            position: relative;
            height: 70px;
            width: 103px;
            cursor: pointer;

            &:hover {
                width: 103px;
                height: 70px;

                .showDelete {
                    display: block;
                }
            }

            .showDelete {
                width: 103px;
                height: 70px;
                background: rgba(0, 0, 0, 0.3);
                display: none;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;
                text-align: center;
                overflow: hidden;
            }

            .showshanchu {
                width: 18px;
                height: 18px;
                margin-top: 26px;
            }
        }
    }

    .show_autor_Picture {
        margin-right: 20px;

        div {
            min-width: 103px;
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 5px;
        }

        .showSc_autor {
            position: relative;
            min-width: 108px;
            height: 38px;
            cursor: pointer;
            margin-top: 0px;
            margin-right: 5px;

            &:hover {
                min-width: 108px;
                height: 38px;

                .showshanchu {
                    display: block;
                }
            }

            .showshanchu {
                width: 14px;
                height: 14px;
                position: absolute;
                top: 6px;
                right: 3px;
                display: none;
                /*margin-top:26px;*/
            }
        }
    }

    .publish_status {
        .pulish_status_span {
            margin-left: 20px;
            margin-right: 15px;
        }
    }

    .autors_class {
        /*width:108px;*/
        min-width: 108px;
        height: 38px;
        background: #ffd800;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        border: none;
        color: #4e4e4e;
        line-height: 24px;
        padding: 0 8px;
    }

</style>
<style type="text/css">
    .ivu-checkbox-wrapper-checked {
        color: #333;
    }

    .ivu-checkbox-indeterminate .ivu-checkbox-inner {
        background-color: #fff !important;
        border-color: #333 !important;
    }

    .ivu-checkbox-checked .ivu-checkbox-inner {
        background-color: #fff !important;
        border-color: #333 !important;
    }

    .ivu-checkbox-indeterminate .ivu-checkbox-inner:after {
        border-color: #333;
    }

    .ivu-checkbox-checked .ivu-checkbox-inner:after {
        border-color: #333;
    }

    .ivu-radio-inner {
        border: 1px solid #b5b5b5;

    }

    .ivu-radio-checked .ivu-radio-inner {
        border-color: #ffd800;
        transition: none;
        transform: none;
    }

    .ivu-radio-inner:after {
        left: 2.5px;
        background-color: #ffd800
    }

    .ivu-radio-checked:hover .ivu-radio-inner {
        border-color: #333;
    }

    /deep/ .radio_item.ivu-radio-wrapper-checked .radio_item_name {
        color: #666666;
        transition: none !important;
        transform: none;
    }

    .ivu-radio-focus {
        box-shadow: none;
    }

    .ivu-checkbox-focus {
        box-shadow: none;
    }

    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
    }

    /*.ivu-input{*/
    /*	height: 40px !important;*/
    /*}*/

    .ivu-input {
        border: 1px solid #E5E7EA;
        border-radius: 0px;
        box-shadow: none;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 21px;
    }

    .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
		color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
		color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
		color: #999999;
    }

    .ivu-input:hover {
        border-color: #ffd800;
    }

    .ivu-input:focus {
        border-color: #ffd800;
        outline: 0;
    }

    .el-textarea__inner:focus {
        outline: 0;
        border-color: #ffd800;
    }

    .el-input.is-active .el-input__inner, .el-input__inner:focus {
        outline: 0;
        border-color: #ffd800;
    }

    .ivu-input-prefix i, .ivu-input-suffix i {
        line-height: 38px;
    }

    input[type=checkbox] {
        width: 14px;
        height: 14px;
        -webkit-appearance: none;
        background-color: transparent;
        border: 0;
        outline: 0 !important;
        color: #d8d8d8;
        position: relative;
    }

    input[type=checkbox]:before {
        content: "";
        display: block;
        width: 14px;
        height: 14px;
        border: 1px solid #ddd;
        background-color: #fff;
        box-sizing: border-box;
        position: absolute;
    }

    input[type=checkbox]:disabled:before {
        content: "";
        display: block;
        width: 14px;
        height: 14px;
        border: 1px solid #333;
        box-sizing: border-box;
        border-radius: 14px;
        position: absolute;
    }

    input[type=checkbox]:checked:before {
        content: "";
        display: block;
        width: 14px;
        height: 14px;
        border: 1px solid rgba(18, 18, 16, 1);
        box-sizing: border-box;
        position: absolute;
    }

    input[type=checkbox]:checked:after {
        content: "\2714";
        display: block;
        width: 10px;
        height: 10px;
        color: #333;
        position: absolute;
        transform: rotate(10deg) translate(18%, -45%);
    }

    .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner {
        border-color: #ffd800;
    }
	.el-input__inner{
		border: 1px solid #dcdee2;
	}
	.el-input__inner:hover{
		border:1px solid #ffd800;
	}
	.el-cascader:not(.is-disabled):hover .el-input__inner{
		border:1px solid #ffd800;

	}
</style>